import React from 'react'
import { topBrands } from "../../data/db.json";
import { Link } from "react-router-dom";

const Discover = () => {
  return (
    <div>
      <h3 className="head head1">DEALS ON TOP BRANDS</h3>
      <div className="cardone main-Content hpr4-div">
        {topBrands.map((brand) => (
          <div className="hpr4">
            <Link
              to={`/product/${parseInt(brand.id)}`}
              style={{ textDecoration: "none", color: "black" }}
            >
              {/* <div className="content"> */}
                <img src={brand} className="card-img-top prod_img" alt="..." />
                {/* <div className="card-body"> */}
                  
                {/* </div> */}
              {/* </div> */}
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Discover